module.exports = __webpack_public_path__ + "d7322b85e600ff6e5a1e5237568ac8f2.pdf";